module.exports = __webpack_public_path__ + "static/media/removedSubmission.9c4d7b91.png";